module.exports = __webpack_public_path__ + "img/car-4.60f655f3.jpg";